module.exports = __webpack_public_path__ + "static/media/generic-error.99cd772b.svg";